import * as z from "zod/v4";

export const applyOptimizationDraft = {
  name: "applyOptimizationDraft" as const,
  input: z.object({
    draftId: z.bigint(),
    fields: z.array(z.string()).optional(),
  }),
  output: z.void(),
};
